import React, { useState } from "react";
import { Menu, X, ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";
import { navLinks } from "../mock";
import Logo from "./Logo";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <>
      <header className="site-header">
        <div className="header-left">
          <button className="header-btn" onClick={() => setMenuOpen(true)} aria-label="Open menu">
            <Menu size={22} strokeWidth={1.25} />
          </button>
        </div>
        <Logo />
        <div className="header-right">
          <button className="header-btn" onClick={() => setCartOpen(true)} aria-label="Open cart">
            <ShoppingBag size={20} strokeWidth={1.25} />
          </button>
        </div>
      </header>

      {/* Menu drawer */}
      <div className={`menu-overlay ${menuOpen || cartOpen ? "open" : ""}`} onClick={() => { setMenuOpen(false); setCartOpen(false); }} />
      <aside className={`menu-drawer ${menuOpen ? "open" : ""}`} aria-hidden={!menuOpen}>
        <button className="menu-close" onClick={() => setMenuOpen(false)} aria-label="Close menu">
          <X size={22} strokeWidth={1.25} />
        </button>
        <nav className="menu-links">
          {navLinks.map((l) => (
            <Link key={l.label} to={l.href} onClick={() => setMenuOpen(false)}>{l.label}</Link>
          ))}
        </nav>
        <div style={{ marginTop: "auto", fontSize: 12, letterSpacing: "0.15em", textTransform: "uppercase", color: "#6b6258" }}>
          Couture · By Invitation
        </div>
      </aside>

      {/* Cart drawer */}
      <aside className={`cart-drawer ${cartOpen ? "open" : ""}`} aria-hidden={!cartOpen}>
        <button className="menu-close" onClick={() => setCartOpen(false)} aria-label="Close cart">
          <X size={22} strokeWidth={1.25} />
        </button>
        <h2 className="cart-title">Shopping Cart</h2>
        <p className="cart-empty">Your cart is currently empty.</p>
        <div style={{ marginTop: 30, fontSize: 12, color: "#6b6258", letterSpacing: "0.05em", lineHeight: 1.6 }}>
          Label Binduu Jain commissions are private and by invitation only. Please register your interest to be considered.
        </div>
      </aside>
    </>
  );
};

export default Header;
